import trafficRowsModel from '../../models/trafficRows'

export function trafficRows(state = trafficRowsModel, action) {
	switch(action.type) {
		case 'BUILD_TRAFFIC_ROW_SUCCESS':
			return action.trafficRowArray

		case 'UPDATE_TRAFFIC_ROW':
			return action.trafficRowArray
			
		default:
			return state
	}
}